import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, delay, ease }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0, onLoad = false }) => {
  const trigger = onLoad
    ? { animate: "show" }
    : { whileInView: "show", viewport: { once: true, amount: 0.1 } };
  return (
    <motion.span className={`block ${className}`} initial="hidden" {...trigger}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className={`block ${lineClass}`}
            variants={{ hidden: { y: "105%" }, show: { y: "0%" } }}
            transition={{ duration: 1.1, delay: delay + i * 0.12, ease }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.3em] text-lime ${className}`}>{children}</p>
);
